'use client';

import { motion } from 'framer-motion';
import Skeleton from './LoadingSkeleton';

export const TestimonialsLoadingSkeleton = () => {
  return (
    <motion.section 
      className="py-20 bg-white"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header Skeleton */}
        <div className="text-center mb-16">
          <Skeleton className="h-4 w-24 mx-auto mb-2" />
          <Skeleton className="h-12 w-48 mx-auto" />
        </div>

        {/* Testimonials Carousel Skeleton */}
        <div className="relative">
          {/* Navigation Arrows Skeleton */}
          <div className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10">
            <Skeleton className="w-12 h-12 rounded-full" />
          </div>
          <div className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10">
            <Skeleton className="w-12 h-12 rounded-full" />
          </div>

          {/* Testimonials Grid Skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Generate 3 testimonial card skeletons */}
            {Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-8">
                {/* Quote Icon Skeleton */}
                <Skeleton className="w-8 h-8 mb-6" />
                
                {/* Testimonial Text Skeleton */}
                <div className="space-y-2 mb-6">
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-3/4" />
                </div>

                {/* Author Section Skeleton */}
                <div className="border-t pt-4">
                  <Skeleton className="h-4 w-32 mb-2" />
                  <Skeleton className="h-3 w-24" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </motion.section>
  );
};
